<template>
  <pagefra>
    <div
      class="propertyQuote container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            :model="form"
            inline
            class="toolbar-form"
            @submit.native.prevent
          >
            <el-form-item :label="$l('确认状态')">
              <el-select
                v-model="form.confirmStatus"
                :placeholder="$l('确认状态')"
                clearable
              >
                <el-option :label="$l('未确认')" :value="0"></el-option>
                <el-option :label="$l('已确认')" :value="1"></el-option>
                <el-option :label="$l('已取消')" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="70"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('报价单编号')"
              prop="quoteNo"
              align="center"
              min-width="160"
            ></el-table-column>
            <el-table-column
              :label="$l('版本号')"
              prop="version"
              align="center"
              min-width="90"
            ></el-table-column>
            <el-table-column
              :label="$l('标题')"
              prop="title"
              align="center"
              min-width="160"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$l('类型')"
              prop="quoteType"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('项目名称')"
              prop="projectName"
              align="center"
              min-width="150"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$l('金额总计')"
              prop="totalAmount"
              align="center"
              min-width="110"
            ></el-table-column>
            <el-table-column
              :label="$l('报价日期')"
              prop="quoteDate"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column :label="$l('状态')" align="center" min-width="100">
              <template slot-scope="scope">
                {{ statusText(scope.row.status) }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('是否有PDF')"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.hasPdf ? $l("是") : $l("否") }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('是否有异议')"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.hasDispute == 1 ? $l("有") : $l("无") }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('提出异议时间')"
              prop="disputedTime"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('是否已读')"
              align="center"
              min-width="90"
            >
              <template slot-scope="scope">
                {{ scope.row.isRead == 1 ? $l("已读") : $l("未读") }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('首次已读时间')"
              prop="readTime"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('是否新版本')"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.isNewVersion ? $l("是") : $l("否") }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('详情')"
              align="center"
              width="90"
              fixed="right"
              v-if="hasPermission('详情')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="openDetailDialog(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('确认')"
              align="center"
              width="90"
              fixed="right"
              v-if="hasPermission('确认')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status === 'DISPATCHED'"
                  type="text"
                  icon="el-icon-circle-check"
                  class="table-icon"
                  @click="confirmQuote(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('转发')"
              align="center"
              width="90"
              fixed="right"
              v-if="hasPermission('转发')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.hasPdf"
                  type="text"
                  icon="el-icon-message"
                  class="table-icon"
                  @click="openForwardDialog(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('提交异议')"
              align="center"
              width="110"
              fixed="right"
              v-if="hasPermission('提交异议')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status === 'DISPATCHED'"
                  type="text"
                  icon="el-icon-warning-outline"
                  class="table-icon"
                  @click="submitDispute(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :visible.sync="detailVisible"
        :title="$l('报价单详情')"
        width="960px"
        :close-on-click-modal="false"
        custom-class="quote-detail-dialog"
      >
        <div class="quote-detail">
          <div class="quote-detail__section">
            <div class="quote-detail__title">
              {{ $l("当前版本信息") }}
              <el-tag
                v-if="detail.current.isNewVersion"
                type="danger"
                size="mini"
                class="quote-detail__new-tag"
                >{{ $l("新版本！") }}</el-tag
              >
            </div>
            <div class="quote-detail__grid">
              <div class="quote-detail__cell">
                <span class="label">{{ $l("报价单编号") }}</span>
                <span class="value">{{
                  displayVal(detail.current.quoteNo)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("版本号") }}</span>
                <span class="value">{{
                  displayVal(detail.current.version)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("报价类型") }}</span>
                <span class="value">{{
                  quoteTypeText(detail.current.quoteType)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("状态") }}</span>
                <span class="value">{{
                  statusText(detail.current.status)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("甲方名称") }}</span>
                <span class="value">{{
                  displayVal(detail.current.partyAName)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("乙方名称") }}</span>
                <span class="value">{{
                  displayVal(detail.current.partyBName)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("签约地点") }}</span>
                <span class="value">{{
                  displayVal(detail.current.signingLocation)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("报价日期") }}</span>
                <span class="value">{{
                  displayVal(detail.current.quoteDate)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("项目名称") }}</span>
                <span class="value">{{
                  displayVal(detail.current.projectName)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("标题") }}</span>
                <span class="value">{{
                  displayVal(detail.current.title)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("税率") }}</span>
                <span class="value">{{
                  detail.current.taxRate != null
                    ? detail.current.taxRate + "%"
                    : "-"
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("币种") }}</span>
                <span class="value">{{
                  displayVal(detail.current.currency)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("材料费合计") }}</span>
                <span class="value">{{
                  displayVal(detail.current.materialTotal)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("人工费合计") }}</span>
                <span class="value">{{
                  displayVal(detail.current.laborTotal)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("未税合计") }}</span>
                <span class="value">{{
                  displayVal(detail.current.untaxedTotal)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("税额合计") }}</span>
                <span class="value">{{
                  displayVal(detail.current.taxTotal)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("含税总金额") }}</span>
                <span class="value">{{
                  displayVal(detail.current.totalAmount)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("推送时间") }}</span>
                <span class="value">{{
                  displayVal(detail.current.dispatchedTime)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("确认时间") }}</span>
                <span class="value">{{
                  displayVal(detail.current.confirmedTime)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("作废时间") }}</span>
                <span class="value">{{
                  displayVal(detail.current.obsoleteTime)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("取消时间") }}</span>
                <span class="value">{{
                  displayVal(detail.current.cancelledTime)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("是否有异议") }}</span>
                <span class="value">{{
                  disputeText(detail.current.hasDispute)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("提出异议时间") }}</span>
                <span class="value">{{
                  displayVal(detail.current.disputedTime)
                }}</span>
              </div>
              <div class="quote-detail__cell">
                <span class="label">{{ $l("是否已读") }}</span>
                <span class="value">{{ readText(detail.current.isRead) }}</span>
              </div>
              <div class="quote-detail__cell quote-detail__cell--last">
                <span class="label">{{ $l("首次已读时间") }}</span>
                <span class="value">{{
                  displayVal(detail.current.readTime)
                }}</span>
              </div>
            </div>
          </div>
          <div class="quote-detail__section">
            <div class="quote-detail__title">{{ $l("版本列表") }}</div>
            <el-table
              :data="detail.versions"
              size="small"
              border
              max-height="360"
              style="width: 100%"
            >
              <el-table-column
                :label="$l('版本号')"
                prop="version"
                align="center"
                min-width="70"
              ></el-table-column>
              <el-table-column
                :label="$l('状态')"
                align="center"
                min-width="90"
              >
                <template slot-scope="scope">
                  {{ statusText(scope.row.status) }}
                </template>
              </el-table-column>
              <el-table-column
                :label="$l('报价金额')"
                prop="amount"
                align="center"
                min-width="90"
              ></el-table-column>
              <el-table-column
                :label="$l('是否有PDF')"
                align="center"
                min-width="90"
              >
                <template slot-scope="scope">
                  {{ scope.row.hasPdf ? $l("是") : $l("否") }}
                </template>
              </el-table-column>
              <el-table-column
                :label="$l('是否有异议')"
                align="center"
                min-width="90"
              >
                <template slot-scope="scope">
                  {{ disputeText(scope.row.hasDispute) }}
                </template>
              </el-table-column>
              <el-table-column
                :label="$l('是否已读')"
                align="center"
                min-width="80"
              >
                <template slot-scope="scope">
                  {{ readText(scope.row.isRead) }}
                </template>
              </el-table-column>
              <el-table-column
                :label="$l('创建时间')"
                prop="createdTime"
                align="center"
                min-width="150"
              ></el-table-column>
              <el-table-column
                :label="$l('发送时间')"
                prop="dispatchedTime"
                align="center"
                min-width="150"
              ></el-table-column>
              <el-table-column
                :label="$l('确认时间')"
                prop="confirmedTime"
                align="center"
                min-width="150"
              ></el-table-column>
              <el-table-column
                :label="$l('作废时间')"
                prop="obsoleteTime"
                align="center"
                min-width="150"
              ></el-table-column>
              <el-table-column
                :label="$l('取消时间')"
                prop="cancelledTime"
                align="center"
                min-width="140"
              ></el-table-column>
              <el-table-column
                :label="$l('提出异议时间')"
                prop="disputedTime"
                align="center"
                min-width="150"
              ></el-table-column>
              <el-table-column
                :label="$l('首次已读时间')"
                prop="readTime"
                align="center"
                min-width="150"
              ></el-table-column>
              <el-table-column
                :label="$l('下载')"
                align="center"
                width="90"
                fixed="right"
                v-if="hasPermission('下载')"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.hasPdf"
                    type="text"
                    icon="el-icon-download"
                    class="table-icon"
                    @click="getQuotesPdf(scope.row, 'download')"
                  ></el-button>
                  <span v-else class="quote-ops__empty">-</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$l('预览')"
                align="center"
                width="90"
                fixed="right"
                v-if="hasPermission('预览')"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.hasPdf"
                    type="text"
                    icon="el-icon-view"
                    class="table-icon"
                    @click="getQuotesPdf(scope.row, 'preview')"
                  ></el-button>
                  <span v-else class="quote-ops__empty">-</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div slot="footer" class="quote-dialog__footer">
          <el-button @click="detailVisible = false">关 闭</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="forwardVisible"
        :title="$l('转发报价单PDF')"
        width="480px"
        :close-on-click-modal="false"
      >
        <el-form
          ref="forwardForm"
          class="forward-form"
          :model="forwardForm"
          :rules="forwardRules"
          label-width="100px"
        >
          <el-form-item :label="$l('收件邮箱')" prop="email">
            <el-input
              v-model="forwardForm.email"
              :placeholder="$l('请输入收件邮箱')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="forwardVisible = false">{{
            $l("取 消")
          }}</el-button>
          <el-button
            type="primary"
            :loading="forwardLoading"
            @click="submitForward"
            >{{ $l("确 定") }}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "propertyQuote",
  mixins: [global],
  components: {
    panel,
  },
  data() {
    return {
      form: {
        confirmStatus: "",
      },
      tableData: [],
      loading: false,
      fullLoading: false,
      detailVisible: false,
      detail: {
        current: {},
        versions: [],
      },
      forwardVisible: false,
      forwardLoading: false,
      forwardRow: {},
      forwardForm: {
        email: "",
      },
      forwardRules: {
        email: [
          {
            required: true,
            message: this.$l("请输入收件邮箱"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$l("邮箱格式不正确"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.pageConfig.pageChangeCallback = this.loadData;
  },
  mounted() {
    this.loadData();
  },
  methods: {
    search() {
      this.pageConfig.currentPage = 1;
      this.loadData();
    },
    statusText(status) {
      const map = {
        PENDING_PDF: "待生成PDF",
        PDF_READY: "PDF已就绪",
        DISPATCHED: "待确认",
        CONFIRMED: "已确认",
        OBSOLETE: "已作废",
        CANCELLED: "已取消",
      };
      return map[status] || status || "-";
    },
    quoteTypeText(type) {
      const map = {
        MAINTENANCE: "维保",
        REPAIR: "维修",
      };
      return map[type] || type || "-";
    },
    disputeText(value) {
      if (value == 1) {
        return this.$l("有");
      }
      if (value == 0) {
        return this.$l("无");
      }
      return "-";
    },
    readText(value) {
      if (value == 1) {
        return this.$l("已读");
      }
      if (value == 0) {
        return this.$l("未读");
      }
      return "-";
    },
    displayVal(value) {
      if (value === undefined || value === null || value === "") {
        return "-";
      }
      return value;
    },
    openDetailDialog(row) {
      this.detail = {
        current: {},
        versions: [],
      };
      this.fullLoading = true;
      this.loadDetail(row);
    },
    loadDetail(row) {
      const quoteNo = (row && row.quoteNo) || "";
      const params = { quoteNo };
      if (row && row.version) {
        params.version = row.version;
      }
      this.$http
        .get(this.$apiConfig.get_fd_quotes_detail_url, {
          params,
        })
        .then((response) => {
          this.fullLoading = false;
          const result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.detail = {
              current: data.current || {},
              versions: data.versions || [],
            };
            this.detailVisible = true;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    confirmQuote(row) {
      this.$confirm(this.$l("是否确认该报价单？"), this.$l("提示"), {
        confirmButtonText: this.$l("确定"),
        cancelButtonText: this.$l("取消"),
        type: "warning",
      })
        .then(() => {
          this.fullLoading = true;
          this.$http
            .post(this.$apiConfig.fd_quotes_confirm_url, {
              quoteNo: row.quoteNo,
              version: row.version,
            })
            .then((response) => {
              this.fullLoading = false;
              const result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.loadData();
              }
            })
            .catch((error) => {
              this.fullLoading = false;
              this.errorMessage();
              this.$sentry.captureException(error);
            });
        })
        .catch(() => {});
    },
    submitDispute(row) {
      this.$confirm(this.$l("是否提交该报价单的异议？"), this.$l("提示"), {
        confirmButtonText: this.$l("确定"),
        cancelButtonText: this.$l("取消"),
        type: "warning",
      })
        .then(() => {
          this.fullLoading = true;
          this.$http
            .post(this.$apiConfig.fd_quotes_dispute_url, {
              quoteNo: row.quoteNo,
              version: row.version,
            })
            .then((response) => {
              this.fullLoading = false;
              const result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.loadData();
              }
            })
            .catch((error) => {
              this.fullLoading = false;
              this.errorMessage();
              this.$sentry.captureException(error);
            });
        })
        .catch(() => {});
    },
    openForwardDialog(row) {
      this.forwardRow = row;
      this.forwardForm.email = "";
      this.forwardVisible = true;
      this.$nextTick(() => {
        this.$refs.forwardForm.clearValidate();
      });
    },
    submitForward() {
      this.$refs.forwardForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.forwardLoading = true;
        this.fullLoading = true;
        this.$http
          .post(this.$apiConfig.fd_quotes_pdf_forward_url, {
            quoteNo: this.forwardRow.quoteNo,
            version: this.forwardRow.version,
            email: this.forwardForm.email.trim(),
          })
          .then((response) => {
            this.forwardLoading = false;
            this.fullLoading = false;
            const result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.forwardVisible = false;
            }
          })
          .catch((error) => {
            this.forwardLoading = false;
            this.fullLoading = false;
            this.errorMessage();
            this.$sentry.captureException(error);
          });
      });
    },
    getQuotesPdf(row, action) {
      const quoteNo = row.quoteNo || this.detail.current.quoteNo || "";
      const params = {
        quoteNo,
        version: row.version,
      };
      this.fullLoading = true;
      this.$http
        .get(this.$apiConfig.get_fd_quotes_pdf_url, {
          params,
        })
        .then((response) => {
          this.fullLoading = false;
          const result = response.data;
          if (result.code != 0) {
            this.message(result.code, result.msg);
            return;
          }
          const data = result.data || {};
          if (action === "preview") {
            if (data.edocPreviewUrl) {
              window.open(data.edocPreviewUrl);
            } else {
              this.message(-1, "获取预览地址失败");
            }
            return;
          }
          let base64 = data.pdfBase64 || "";
          const base64Index = base64.indexOf("base64,");
          if (base64Index > -1) {
            base64 = base64.substring(base64Index + 7);
          }
          if (!base64) {
            this.message(-1, "获取下载文件失败");
            return;
          }
          const title =
            data.title ||
            (this.detail.current && this.detail.current.title) ||
            quoteNo;
          const filename = title + "_" + row.version + ".pdf";
          const byteString = atob(base64);
          const u8 = new Uint8Array(byteString.length);
          for (let i = 0; i < byteString.length; i++) {
            u8[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([u8], { type: "application/pdf" });
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            const url = window.URL.createObjectURL(blob);
            const aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(5);
          this.$sentry.captureException(error);
        });
    },
    loadData() {
      this.loading = true;
      const params = {
        page: this.pageConfig.currentPage,
        limit: this.pageConfig.pageSize,
      };
      if (
        this.form.confirmStatus !== "" &&
        this.form.confirmStatus !== undefined &&
        this.form.confirmStatus !== null
      ) {
        params.confirmStatus = this.form.confirmStatus;
      }
      this.$http
        .post(this.$apiConfig.get_fd_quotes_list_url, params)
        .then((response) => {
          this.loading = false;
          const result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.tableData = data.records || [];
            this.pageConfig.total = data.total || 0;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.propertyQuote {
  .quote-detail {
    &__section {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    &__title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 700;
      color: #303133;
      margin-bottom: 10px;
      padding-left: 8px;
      border-left: 3px solid #409eff;
    }
    &__new-tag {
      margin-left: 8px;
    }
    &__grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      overflow: hidden;
    }
    &__cell {
      display: flex;
      border-bottom: 1px solid #ebeef5;
      &:nth-child(odd) {
        border-right: 1px solid #ebeef5;
      }
      &--last {
        border-bottom: none;
      }
      .label {
        min-width: 92px;
        flex-shrink: 0;
        padding: 8px 12px;
        color: #909399;
        background: #f5f7fa;
        box-sizing: border-box;
        white-space: nowrap;
      }
      .value {
        flex: 1;
        padding: 8px 12px;
        color: #606266;
        word-break: break-word;
      }
    }
  }
  .forward-form {
    /deep/ .el-form-item__label {
      white-space: nowrap;
    }
  }
  .quote-ops {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 60px;
    height: 28px;
    .table-icon {
      margin: 0;
      & + .table-icon {
        margin-left: 12px;
      }
    }
    &__empty {
      color: #c0c4cc;
    }
  }
}
</style>
